import React, { Component } from 'react';
import styled from 'react-emotion';
import classNames from 'classnames';

const ImageViewerContainer = styled('div')({
  padding: 0,
  textAlign: 'center',
  maxWidth: '400px',
}, ({ width }) => ({
  width,
}));

const Image = styled('img')({
  maxWidth: '400px',
  maxHeight: '400px',
  boder: 0,
  padding: 0,
  margin: 0,
  borderRadius: '10px',
}, ({width, height}) => ({
  width: width,
  height: height,
}));

const Caption = styled('div')({
  fontSize: '0.8em',
  marginBottom: '1.5em',
});

const ThumbnailBar = styled('ul')({
  margin: 0,
  padding: 0,
  listStyle: 'none',
  marginTop: '-4px',
});

const ThumbnailItem = styled('li')({
  display: 'inline',
  margin: 0,
  padding: 0,
  cursor: 'pointer',
  '.selected': {
    opacitiy: '0.4',
  },
});

const ThumbnailImage = styled('img')({
  maxWidth: '50px',
  height: '50px',
  margin: 0,
});

const Thumbnail = ({image, selected, onClick}) => {
  const classes = classNames({ selected });

  return (
    <ThumbnailItem className={classes} onClick={onClick}>
      <ThumbnailImage alt="" src={image} />
    </ThumbnailItem>
  );
};

class ImageViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedImage: props.images ? props.images[0] : null
    };
  }

  selectImage = (index) => {
    this.setState({
      selectedImage: this.props.images[index]
    });
    this.props.onThumbnailClick(index);
  }

  render() {
    const { images, children, width, height, className } = this.props;
    const { selectedImage } = this.state;
    return (
      <ImageViewerContainer width={width} className={className}>
        <Image width={width} height={height} alt=""
          src={selectedImage ? selectedImage.full : null} />
        <ThumbnailBar>
          {images.map((image, index) => (
            <Thumbnail
              key={index}
              image={image.thumb}
              selected={selectedImage === image}
              onClick={() => this.selectImage(index)}
            />
          ))}
        </ThumbnailBar>
        <Caption>
        {children}
        </Caption>
      </ImageViewerContainer>);
  }
}

ImageViewer.defaultProps = {
  images: [],
  onThumbnailClick: () => {},
};

export default ImageViewer;



// WEBPACK FOOTER //
// ./src/components/image-viewer/image-viewer.js